import { render, staticRenderFns } from "./contentForm.vue?vue&type=template&id=2ccb21a6&scoped=true"
import script from "./contentForm.vue?vue&type=script&lang=js"
export * from "./contentForm.vue?vue&type=script&lang=js"
import style0 from "./contentForm.vue?vue&type=style&index=0&id=2ccb21a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb21a6",
  null
  
)

export default component.exports